export * from './translation.actions';



//////////////////
// WEBPACK FOOTER
// ./src/translation/store/actions/index.ts
// module id = 235
// module chunks = 81